<template>
  <b-card>
    <TitleTable titleTable="Familiar" iconTable="fas fa-users" />
    <p class="text-muted">Grupo de una membresía Familiar. Permiso membership-family.manage.</p>
    <b-alert v-if="errorMessage" show variant="danger" dismissible @dismissed="errorMessage = null">{{ errorMessage }}</b-alert>
    <b-alert v-if="pendingInvoiceUrl" show variant="warning">
      Cobro pendiente.
      <b-button size="sm" class="ml-2" variant="warning" :href="pendingInvoiceUrl" target="_blank" rel="noopener">Pagar</b-button>
    </b-alert>
    <b-row class="mb-3">
      <b-col cols="12" md="4">
        <b-form-group label="ID de la membresía del titular" label-for="family-membership-id">
          <b-form-input id="family-membership-id" v-model="membershipId" type="number" min="1" />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" class="d-flex align-items-end">
        <b-button class="mb-3" variant="primary" :disabled="loading" @click="load">Ver grupo</b-button>
      </b-col>
    </b-row>
    <b-table :items="members" :fields="fields" :busy="loading" small responsive show-empty empty-text="Sin integrantes.">
      <template #cell(person)="data">{{ data.item.name }} {{ data.item.lastname }}</template>
      <template #cell(actions)="data">
        <b-button v-if="!data.item.removed_at && !isFamilyHolder(data.item)" size="sm" variant="outline-danger" @click="remove(data.item)">Quitar</b-button>
      </template>
    </b-table>
    <h5 class="mt-3">Agregar integrante</h5>
    <b-row>
      <b-col md="3" class="mb-2"><b-form-input v-model.trim="form.name" placeholder="Nombre" /></b-col>
      <b-col md="3" class="mb-2"><b-form-input v-model.trim="form.lastname" placeholder="Apellido" /></b-col>
      <b-col md="3" class="mb-2"><b-form-input v-model="form.date_birth" placeholder="MM-DD-YYYY" /></b-col>
      <b-col md="3" class="mb-2"><b-form-select v-model="form.relationship" :options="relationships" /></b-col>
      <b-col v-if="showContact" md="3" class="mb-2"><b-form-input v-model.trim="form.phone" placeholder="Teléfono" /></b-col>
      <b-col v-if="showContact" md="3" class="mb-2"><b-form-input v-model.trim="form.email" placeholder="Correo" /></b-col>
    </b-row>
    <b-button variant="primary" :disabled="saving" @click="add">Agregar</b-button>
  </b-card>
</template>

<script>
import { BAlert, BButton, BCard, BCol, BFormGroup, BFormInput, BFormSelect, BRow, BTable } from 'bootstrap-vue'
import TitleTable from '@/components/TitleTable'
import familyApi from '@/core/services/api/admin/consults/membershipFamily'
import { membershipApiMessage } from '@/core/utils/membershipAdmin'
import {
  ageFromDateBirth,
  emptyFamilyMember,
  familyMemberPayload,
  isFamilyHolder,
  memberAudience,
  RELATIONSHIP_OPTIONS,
  unwrapList,
  unwrapRecord,
  validateFamilyMember,
} from '@/core/utils/membershipFamily'

/** Backoffice del plan Familiar. */
export default {
  name: 'MembershipFamilyOffice',
  components: { BAlert, BButton, BCard, BCol, BFormGroup, BFormInput, BFormSelect, BRow, BTable, TitleTable },
  data() {
    return {
      membershipId: '',
      members: [],
      loading: false,
      saving: false,
      errorMessage: null,
      pendingInvoiceUrl: null,
      form: emptyFamilyMember(),
      relationships: RELATIONSHIP_OPTIONS,
      isFamilyHolder,
      fields: [
        { key: 'membership_id', label: 'Membresía' },
        { key: 'person', label: 'Persona' },
        { key: 'relationship', label: 'Parentesco' },
        { key: 'audience', label: 'Audiencia' },
        { key: 'pay_status', label: 'Pago' },
        { key: 'actions', label: '' },
      ],
    }
  },
  computed: {
    showContact() {
      const audience = memberAudience(ageFromDateBirth(this.form.date_birth))
      return audience !== 'child' && audience !== 'underage'
    },
  },
  methods: {
    async load() {
      if (!this.membershipId) return
      this.loading = true
      this.errorMessage = null
      try {
        const response = await familyApi.getFamily(this.membershipId)
        this.members = unwrapList(response)
      } catch (error) {
        this.errorMessage = membershipApiMessage(error, 'No se pudo cargar el grupo.')
      } finally {
        this.loading = false
      }
    },
    async add() {
      const localError = validateFamilyMember(this.form, 'Integrante')
      if (localError) {
        this.errorMessage = localError
        return
      }
      this.saving = true
      this.errorMessage = null
      this.pendingInvoiceUrl = null
      try {
        const response = await familyApi.addMember(this.membershipId, familyMemberPayload(this.form))
        const record = unwrapRecord(response) || {}
        if (record.state === 'pending_payment') this.pendingInvoiceUrl = record.pending_invoice_url
        this.form = emptyFamilyMember()
        await this.load()
      } catch (error) {
        this.errorMessage = membershipApiMessage(error, 'No se pudo agregar al integrante.')
      } finally {
        this.saving = false
      }
    },
    async remove(member) {
      this.errorMessage = null
      try {
        const response = await familyApi.removeMember(this.membershipId, member.membership_id)
        const next = unwrapList(response)
        this.members = next.length ? next : this.members
        if (!next.length) await this.load()
      } catch (error) {
        this.errorMessage = membershipApiMessage(error, 'No se pudo quitar al integrante.')
      }
    },
  },
}
</script>
